<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" md="5" class="px-10 text-center d-flex justify-center">
                    <v-img
                    src="../assets/img/texting.jpg"
                    cover
                    max-width="600px"
                    alt="Woman texting" 
                    class="rounded-xl"
                     /> 
                </v-col>
                <v-col cols="12" md="5" class="px-10">
                    <h1>Surveys</h1>
                    <h2 class="text-h5 font-italic mb-5">Engage, Learn, and Personalise</h2>
                    <div>
                        Create interactive surveys that work seamlessly across SMS, MMS, Email, and Voice channels.
                        <ol class="mt-3">
                            <li class="mb-3"><b>Decision Tree Logic:</b> Build custom question flows that adapt based on each response, creating a tailored experience for every participant.</li>

                            <li class="mb-3"><b>Multi-Channel Reach:</b> Conduct surveys wherever your audience prefers to engage — text message, multimedia content, email links, or automated voice calls.</li>

                            <li class="mb-3"><b>Data Collection & Insights:</b> Automatically capture and store every answer, then visualise results to inform your next campaign or business decision.</li>

                            <li class="mb-3"><b>Personalised Follow-Ups:</b> Use responses to trigger targeted messages, offers, or service updates — all powered by Yabbr Workflows.</li>
                        </ol>
                        Surveys turn your outreach into a two-way exchange, gathering valuable feedback while strengthening customer relationships.
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'CampaignsSurveys',
}
</script>

<style lang="scss">

hr {
    margin: 1em 0;
    width: 50%;
}

</style>